import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { DictionaryField } from '../../../../gk-dynamic-list/services/dictionary/dictionary.model';
import { CaseSelectFromApi } from './case-select.model';

@Injectable()
export class CaseSelectService {
  private caseSelectMap = new Map<string, Observable<DictionaryField[]>>();

  constructor(private httpClient: HttpClient) {}

  get(url: string): Observable<DictionaryField[]> {
    let requestModes$ = this.caseSelectMap.get(url);

    if (!requestModes$) {
      requestModes$ = this.httpClient.get<CaseSelectFromApi[]>(url).pipe(
        map((modes) =>
          modes.map(
            (mode) => new DictionaryField(mode.DokUuid, mode.RdSprawaSygnatura),
          ),
        ),
        shareReplay(1),
      );
      this.caseSelectMap.set(url, requestModes$);
    }

    return requestModes$;
  }
}
